import { React, useContext } from 'react';
import Icon from "../../../components/atoms/Icon";
import SportIcon from "../../../components/atoms/SportIcon";
import { ThemeContext } from '../../../components/molecules/Nav';
import '../concession.css';

const ConcessionHeaderNav = ({
    currentLocation,
    isToday,
    selectedDate,
    setDayType,
    dayType,
}) => {
    const [theme] = useContext(ThemeContext);
    // The S3 logo (same as the Locations card) first; the bundled file only for locations without one.
    // A missing bundled file shows no logo instead of crashing the page.
    const localLogo = (path) => {
        if (!path) return null;
        try {
            return require(`../../../clients/${path}`);
        } catch (e) {
            return null;
        }
    };
    const logo = currentLocation?.logoMobileURL
        || (theme === "light" ? localLogo(currentLocation?.logoPath) : localLogo(currentLocation?.logoPathDark) || localLogo(currentLocation?.logoPath));

    return (
        <div className="cx-header">
            <div className="cx-header-identity">
                {logo && (
                    <>
                        <img className="cx-header-logo" src={logo} alt="logo" />
                        <div className="cx-header-divider" />
                    </>
                )}
                <div style={{ minWidth: 0 }}>
                    <div className="cx-eyebrow">Concessions</div>
                    <h1 className="cx-header-title">{currentLocation?.name}</h1>
                </div>
            </div>

            <div className="cx-header-actions">
                {isToday && selectedDate && (
                    <span className="cx-live-pill">
                        <span className="pulsing-dot" />
                        Live
                    </span>
                )}
                <div className="cx-segmented" role="tablist">
                    <button
                        type="button"
                        role="tab"
                        aria-selected={dayType === "overview"}
                        onClick={() => setDayType("overview")}
                        className={`cx-segmented-btn ${dayType === "overview" ? "active" : ""}`}
                    >
                        <Icon name="graph-up" />
                        Overview
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={dayType === "game"}
                        onClick={() => setDayType("game")}
                        className={`cx-segmented-btn ${dayType === "game" ? "active" : ""}`}
                    >
                        <SportIcon fontSize="inherit" />
                        Game Day
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConcessionHeaderNav;
